import styles from './index.less';
import { useModel } from '@umijs/max';
import { queryPaymentBillRecordList } from '@/pages/PaymentRecord/service';
import { useEffect, useState } from 'react';
import {
  auditStatusEnum,
  billTypeEnum,
  billTypeMap,
  checkoutStatusEnum,
  paymentBillType,
} from '@/pages/PaymentRecord/interface';
import NoData from '@/components/NoData';
import { Skeleton, Collapse } from 'react-vant';
import CustomerDefaultInformation from '@/components/CustomerDefaultInformation';
import { ArrowUp, ArrowDown } from '@react-vant/icons';

const PaymentRecord = () => {
  const { defaultCustomerInformation } = useModel(
    'useDefaultCustomer',
    (model) => ({
      defaultCustomerInformation: model.defaultCustomerInformation,
    }),
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [paymentBillList, setPaymentBillList] = useState<paymentBillType[]>([
    {
      billType: billTypeEnum.GENERAL,
      expand: false,
      paymentBillRecordList: [],
      id: Math.random(),
    },
    {
      billType: billTypeEnum.METER,
      expand: false,
      paymentBillRecordList: [],
      id: Math.random(),
    },
  ]);

  const loadGeneralPaymentRecordList = () => {
    queryPaymentBillRecordList({
      customerId: defaultCustomerInformation?.sequenceNbr,
      billType: billTypeEnum.GENERAL,
      auditStatus: auditStatusEnum.APPROVED,
      checkoutStatus: checkoutStatusEnum.SETTLEMENT,
    }).then((res) => {
      if (res?.code === 200) {
        setPaymentBillList((prevState) => {
          return prevState.map((item) => {
            if (item.billType === billTypeEnum.GENERAL) {
              return {
                ...item,
                paymentBillRecordList: res?.rows || [],
              };
            }
            return item;
          });
        });
      }
    });
  };

  const loadMeterPaymentRecordList = () => {
    queryPaymentBillRecordList({
      customerId: defaultCustomerInformation?.sequenceNbr,
      billType: billTypeEnum.METER,
      auditStatus: auditStatusEnum.APPROVED,
      checkoutStatus: checkoutStatusEnum.SETTLEMENT,
    }).then((res) => {
      if (res?.code === 200) {
        setPaymentBillList((prevState) => {
          return prevState.map((item) => {
            if (item.billType === billTypeEnum.METER) {
              return {
                ...item,
                paymentBillRecordList: res?.rows || [],
              };
            }
            return item;
          });
        });
      }
    });
  };

  const loadData = () => {
    setLoading(true);
    Promise.all([
      loadMeterPaymentRecordList(),
      loadGeneralPaymentRecordList(),
    ]).finally(() => setLoading(false));
  };

  useEffect(() => {
    if (defaultCustomerInformation?.sequenceNbr) {
      loadData();
    }
  }, [defaultCustomerInformation]);

  const handleExpandChange = (billType: billTypeEnum) => {
    setPaymentBillList((prevState) => {
      return prevState.map((item) => {
        if (item.billType === billType) {
          return {
            ...item,
            expand: !item.expand,
          };
        }
        return item;
      });
    });
  };

  return (
    <div className={styles.container}>
      <CustomerDefaultInformation />
      <Skeleton loading={loading}>
        {paymentBillList.length ? (
          <>
            {paymentBillList.map((item) => (
              <div key={item.id} className={styles.content}>
                <div className={styles.title}></div>
                <div className={styles.bill}>
                  <div className={styles['bill-amount']}>
                    <div className={styles.amount}>
                      <span> 账单类型：</span>
                      <p>{billTypeMap[item.billType]}</p>
                    </div>
                    <div
                      onClick={() => handleExpandChange(item.billType)}
                      className={styles['bill-expand']}
                    >
                      {item.expand ? <ArrowUp /> : <ArrowDown />}
                    </div>
                  </div>
                  {/*<div className={styles.text}>*/}
                  {/*  缴费时间：*/}
                  {/*  {formattedDate(item.creatorTime, 'YYYY-MM-DD HH:mm:ss')}*/}
                  {/*</div>*/}
                  {/*<div className={styles.text}>*/}
                  {/*  实收金额：￥{item.receivableAmount}*/}
                  {/*</div>*/}
                  {item.expand && item.paymentBillRecordList.length !== 0 && (
                    <div className={styles.info}>
                      <div className={styles['info-title']}>
                        <div className={styles['title-text']}>账单月份</div>
                        <div className={styles['title-text']}>单价</div>
                        <div className={styles['title-text']}>
                          收款金额（元）
                        </div>
                      </div>
                      <Collapse className={styles['info-content']} accordion>
                        {item.paymentBillRecordList.map((bill) => (
                          <Collapse.Item
                            key={bill.sequenceNbr!}
                            title={
                              <div className={styles['collapse-title']}>
                                <div className={styles['title-text']}>
                                  {bill.billMonth}
                                </div>
                                <div className={styles['title-text']}>
                                  {bill.priceOrAmount}
                                </div>
                                <div className={styles['title-text']}>
                                  ¥ {bill.totalAmount}
                                </div>
                              </div>
                            }
                          >
                            <div className={styles['bill-item']}>
                              <div>
                                <span>{bill.feeItemName}</span>
                                <p>¥ {bill.totalAmount}</p>
                              </div>
                              <div>
                                <span>优惠</span>
                                <p>¥ {bill.discountAmount}</p>
                              </div>
                              <div>
                                <span>冲抵</span>
                                <p>¥ {bill.balanceDeduction}</p>
                              </div>
                              <div>
                                <span>缴费时间</span>
                                <p> {bill.checkoutTime}</p>
                              </div>
                            </div>
                          </Collapse.Item>
                        ))}
                      </Collapse>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : (
          <NoData />
        )}
      </Skeleton>
    </div>
  );
};

export default PaymentRecord;
